@if (!roleConnection?.isHistoric() && handoverStatusMetadata; as handoverStatusMeta) {
    <i [ngClass]="handoverStatusMeta.icon"
       [adaptTooltip]="handoverStatusMeta.name"></i>
}
